import { nestedFieldConstructor } from "scenes/cohort-filters/filter-configs/fieldContructors/nestedField";
import { Category } from "scenes/cohort-filters/filter-configs/categories";
import {
    autocompleteFieldConstructor,
    dropdownFieldConfigConstructor,
} from "scenes/cohort-filters/filter-configs/fieldContructors";

export const medicationsFields = {
    ...nestedFieldConstructor({
        nestedPath: "medications",
        category: Category.MEDICATIONS,
        label: "medication.ingredient",
        allowAndCondition: true,
        allowOrCondition: true,
        showLabel: false,
        andConditionLabel: "cohort.add-to-group.medication",
        canExclude: true,
        virtualFieldPaths: ["medCriteria"],
        nestedConfigs: [
            autocompleteFieldConstructor({
                pathToValue: "medications.ingredient",
                label: "medication.table.ingredient",
                nestedComponent: true,
            }),
            dropdownFieldConfigConstructor({
                pathToValue: "medCriteria",
                dropdownValues: [
                    { value: "ACTIVE", label: "cohort.actual-subscription" },
                    { value: "NON_ACTIVE", label: "cohort.past-subscription" },
                    { value: "NEVER_SUBSCRIBED", label: "cohort.never-subscribed" },
                ],
                label: "cohort.criteria",
                fieldWidth: 208,
                nestedComponent: true,
            }),
        ],
    }),
};
